import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '../../core/helpers/isMobile';
import { userInfoStore } from '../../store/userInfoStore';
import './bet-button.scss';
import { isPG } from '../../core/helpers/skinHelper';
import { freeBetStore } from '../../store/freeBetStore';

const BetButton = observer(
  ({
    text,
    clickHandler,
    className,
    classNameButtonText,
    isDoSpinStart,
    children,
    isDisabled,
    isShowFreeBetCount,
    mouseDownHandler = () => {},
    mouseUpHandler = () => {},
    mouseMoveHandler = () => {},
    mouseLeaveHandler = () => {},
    currencyCode = null,
    isShowBetButtonAnimation = false,
    animatedIconSrc = '',
    isTwoLine = false,
    additionalInfo = null,
    additionalDataValue = null,
    AdditionalComponent = null,
    wrapperAdditionalClass = '',
    isDisableStyleInAnimation = true,
    isShowAdditionalComp = false,
    onKeyDown,
  }) => {
    const { currentFreeBet } = freeBetStore;
    const getFontSizeClassByTextLength = (txt) => {
      const len = txt?.length || 0;
      if (len >= 10 && len <= 14) return 'fz-1';
      if (len >= 15 && len <= 23) return 'fz-2';
      if (len >= 24 && len <= 32) return 'fz-3';
      if (len > 32) return 'fz-4';
      return ''; // Default, no class applied
    };

    const fontSizeClass = getFontSizeClassByTextLength(text);
    return (
      // ToDO: add ".with-animation-bet" class to "cpt-bet-big-button-wrapper" when bet button have animation
      <div
        className={`cpt-bet-big-button-wrapper ${
          isDisabled && isShowBetButtonAnimation ? 'with-animation-bet' : ''
        } ${isDisabled ? 'disable_shadow' : ''} 
        ${wrapperAdditionalClass}`}
        onMouseDown={() => !isMobile() && mouseDownHandler()}
        onPointerDown={mouseDownHandler}
        onMouseUp={() => !isMobile() && mouseUpHandler()}
        onTouchEnd={mouseUpHandler}
        onMouseMove={() => !isMobile() && mouseMoveHandler()}
        onTouchMove={mouseMoveHandler}
        onMouseLeave={() => !isMobile() && mouseLeaveHandler()}
      >
        <button
          onKeyDown={onKeyDown}
          onClick={clickHandler}
          className={`cpt-bet-big-button ${className} ${
            isDisabled && isDisableStyleInAnimation ? 'disabled' : ''
          }`}
          onBlur={() => {}}
          tabIndex={-1}
        >
          {AdditionalComponent && (
            <AdditionalComponent isShowAdditionalComp={isShowAdditionalComp} />
          )}
          <span
            className={`cpt-bet-big-button-txt-container ${classNameButtonText} ${
              isTwoLine ? 'cpt-col' : ''
            } `}
          >
            {/* ToDo add has-value class on bottom span when cpt-cashout-value length > 0 */}
            <span
              className={`cpt-bet-big-button-txt ${fontSizeClass} ${
                additionalDataValue ? 'has-value' : ''
              }`}
              data-value={additionalDataValue}
            >
              <span className='cpt-bet-big-button-txt-title'>
                {text}
                {isShowFreeBetCount ||
                  (!isDoSpinStart && currentFreeBet && <>({currentFreeBet?.remainingCount})</>)}
              </span>

              {isPG() && !!additionalDataValue && (
                <span className='cpt-cashout-value-txt'>
                  {additionalDataValue}
                  {currencyCode || userInfoStore.currencyCode}
                </span>
              )}
              {children}
            </span>
          </span>
          {/* ToDo: show or hide span .cpt-bet-big-button-value to see bet value */}
          {additionalInfo ? (
            <span className='cpt-bet-big-button-value'>
              {additionalInfo}
              {currencyCode || userInfoStore.currencyCode}
            </span>
          ) : null}
          {/* ToDo: show or hide bet-rotate-btn div when we have .with-animation-bet class before */}
          {isDisabled && isShowBetButtonAnimation ? (
            <div className='bet-rotate-btn'>
              <span>
                <img src={animatedIconSrc} alt='' />
              </span>
            </div>
          ) : null}
        </button>
      </div>
    );
  }
);

export default BetButton;
